import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { translations } from "../../translations";
import "./EventsPage.css";

const events = [
  {
    id: "27-dec-2025-guru-gobind-singh-gurpurab",
    title: {
      en: "Guru Gobind Singh Ji Gurpurab",
      hi: "गुरु गोबिंद सिंह जी गुरपुरब",
      pa: "ਗੁਰੂ ਗੋਬਿੰਦ ਸਿੰਘ ਜੀ ਗੁਰਪੁਰਬ",
      fr: "Gurpurab de Guru Gobind Singh Ji"
    },
    date: {
      en: "December 27, 2025",
      hi: "27 दिसंबर, 2025",
      pa: "27 ਦਸੰਬਰ, 2025",
      fr: "27 décembre 2025"
    },
    time: "6:00 AM - 6:00 PM",
    venue: {
      en: "Gurdwara Nanaksar, Winnipeg",
      hi: "गुरुद्वारा नानकसर, विनीपेग",
      pa: "ਗੁਰਦੁਆਰਾ ਨਾਨਕਸਰ, ਵਿਨੀਪੈਗ",
      fr: "Gurdwara Nanaksar, Winnipeg"
    },
    description: {
      en: "Celebrate the birth anniversary of the Tenth Sikh Guru with Sri Sukhmani Sahib Path, Path Bhog, and Langar Sewa",
      hi: "दसवें सिख गुरु की जयंती मनाएं - श्री सुखमनी साहिब पाठ, पाठ भोग और लंगर सेवा",
      pa: "ਦਸਵੇਂ ਸਿੱਖ ਗੁਰੂ ਦਾ ਪ੍ਰਕਾਸ਼ ਪੁਰਬ ਮਨਾਓ - ਸ੍ਰੀ ਸੁਖਮਨੀ ਸਾਹਿਬ ਪਾਠ, ਪਾਠ ਭੋਗ ਅਤੇ ਲੰਗਰ ਸੇਵਾ",
      fr: "Célébrez l'anniversaire du dixième Gourou Sikh avec Sri Sukhmani Sahib Path et Langar"
    },
    category: {
      en: "Religious",
      hi: "धार्मिक",
      pa: "ਧਾਰਮਿਕ",
      fr: "Religieux"
    },
    icon: "☬",
    featured: true,
  },
];

export const EventsPage = () => {
  const { language } = useLanguage();
  const t = translations.events[language] || translations.events.en;

  return (
    <div className="events-page">
      {/* Header */}
      <header className="events-header">
        <div className="container">
          <span className="location-badge">📍 Winnipeg, Manitoba</span>
          <h1>{t.title}</h1>
          <p>{t.subtitle}</p>
        </div>
      </header>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-card">
            <div className="mission-icon">🤝</div>
            <h2>{t.missionTitle}</h2>
            <p>{t.missionText}</p>
          </div>
        </div>
      </section>

      {/* Events List */}
      <section className="events-list-section">
        <div className="container">
          <h2>{t.upcomingTitle}</h2>
          <div className="events-grid">
            {events.map((event) => (
              <Link to={`/community/${event.id}`} key={event.id} className={`event-card ${event.featured ? 'featured' : ''}`}>
                {event.featured && <span className="featured-badge">{t.featuredTitle}</span>}
                <div className="event-icon">{event.icon}</div>
                <div className="event-category">{event.category[language] || event.category.en}</div>
                <h3>{event.title[language] || event.title.en}</h3>
                {language !== 'pa' && <p className="event-title-pa">{event.title.pa}</p>}
                <div className="event-meta">
                  <span className="event-date">📅 {event.date[language] || event.date.en}</span>
                  <span className="event-time">⏰ {event.time}</span>
                </div>
                <p className="event-venue">📍 {event.venue[language] || event.venue.en}</p>
                <p className="event-description">{event.description[language] || event.description.en}</p>
                <span className="view-details">{t.viewDetails} →</span>
              </Link>
            ))}
          </div>

          {events.length === 1 && (
            <div className="more-events-note">
              <p>{language === 'en' ? 'More events coming soon! Stay tuned for upcoming community gatherings.' : 
                  language === 'hi' ? 'और कार्यक्रम जल्द आ रहे हैं! आगामी सामुदायिक समारोहों के लिए बने रहें।' : 
                  language === 'pa' ? 'ਹੋਰ ਸਮਾਗਮ ਜਲਦੀ ਆ ਰਹੇ ਹਨ! ਆਉਣ ਵਾਲੇ ਕਮਿਊਨਿਟੀ ਸਮਾਗਮਾਂ ਲਈ ਬਣੇ ਰਹੋ।' : 
                  "Plus d'événements à venir bientôt! Restez à l'écoute."}</p>
            </div>
          )}
        </div>
      </section>

      {/* Built By Section */}
      <section className="sponsors-section">
        <div className="container">
          <h2>{language === 'en' ? 'Event Pages Built By' : language === 'hi' ? 'इवेंट पेज निर्माता' : language === 'pa' ? 'ਇਵੈਂਟ ਪੇਜ ਬਿਲਡਰ' : 'Pages Créées Par'}</h2>
          <div className="sponsors-grid">
            <a href="https://9reason.com" target="_blank" rel="noopener noreferrer" className="sponsor-card">
              <div className="sponsor-logo">
                <svg viewBox="0 0 60 60">
                  <rect width="60" height="60" rx="12" fill="#4F46E5"/>
                  <text x="30" y="40" fontFamily="sans-serif" fontSize="32" fontWeight="700" fill="#fff" textAnchor="middle">9</text>
                </svg>
              </div>
              <h3>9Reason</h3>
              <p>{language === 'en' ? 'Software Development Agency' : language === 'hi' ? 'सॉफ्टवेयर डेवलपमेंट एजेंसी' : language === 'pa' ? 'ਸਾਫਟਵੇਅਰ ਡਿਵੈਲਪਮੈਂਟ ਏਜੰਸੀ' : 'Agence de Développement Logiciel'}</p>
            </a>
            <a href="https://realtorparmindersingh.ca" target="_blank" rel="noopener noreferrer" className="sponsor-card">
              <div className="sponsor-logo realtor">🏠</div>
              <h3>Realtor Parminder Singh</h3>
              <p>{language === 'en' ? 'Your Trusted Real Estate Partner' : language === 'hi' ? 'आपका विश्वसनीय रियल एस्टेट पार्टनर' : language === 'pa' ? 'ਤੁਹਾਡਾ ਭਰੋਸੇਮੰਦ ਰੀਅਲ ਅਸਟੇਟ ਸਾਥੀ' : 'Votre Partenaire Immobilier de Confiance'}</p>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="events-footer">
        <div className="container">
          <p>© 2025 9Reason • {language === 'en' ? 'Serving the Winnipeg Community with' : language === 'hi' ? 'विनीपेग समुदाय की सेवा' : language === 'pa' ? 'ਵਿਨੀਪੈਗ ਕਮਿਊਨਿਟੀ ਦੀ ਸੇਵਾ' : 'Au service de la communauté de Winnipeg avec'} ❤️</p>
          <div className="footer-links">
            <Link to="/">{language === 'en' ? 'Home' : language === 'hi' ? 'होम' : language === 'pa' ? 'ਹੋਮ' : 'Accueil'}</Link>
            <a href="https://9reason.com/#contact">{language === 'en' ? 'Contact' : language === 'hi' ? 'संपर्क' : language === 'pa' ? 'ਸੰਪਰਕ' : 'Contact'}</a>
          </div>
        </div>
      </footer>
    </div>
  );
};
